import React, { useState } from 'react'
import './stats.css'
import FilterTrans from '../../components/trans/FilterTrans';
import StatsData from '../../components/statsData/StatsData';

function Stats() {

    const [transactions, setTransactions] = useState([]);

    const handleTransactionsUpdate = (updatedTransactions) => {
        setTransactions(updatedTransactions);
    }
    return (
    <div className='stats'>
        <StatsData transactions={transactions} />    
        <FilterTrans onTransactionsUpdate={handleTransactionsUpdate} />
    </div>
  )
}

export default Stats